import type { User } from 'firebase/auth';
import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { settingsService } from '@/services';

export function useSettings(user: User | null) {
  const queryClient = useQueryClient();

  const { data: settings, isLoading } = useQuery({
    queryKey: ['userSettings', user?.uid],
    queryFn: () => (user ? settingsService.getSettings(user.uid) : null),
    enabled: !!user,
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!user) return;

    const unsubscribe = settingsService.subscribeToSettings(user.uid, updated => {
      queryClient.setQueryData(['userSettings', user.uid], updated);
    });

    return () => unsubscribe();
  }, [user, queryClient]);

  return { settings: settings ?? null, isLoading };
}
